<div>
    <p-menubar [model]="topMenuItems"></p-menubar>
</div>
<div>
    <h3>Create new invoice (Paid)</h3>
</div>
<p-dialog [(visible)]="isSupplierDialogVisible" [modal]="true" header="Add new supplier">
    <div class="supplier-form-container">
        <div [formGroup]="supplierForm">
            <span>
                Name
            </span>
            <input pInputText formControlName="name">
        </div>
        <div>
            <p-button label="Submit" (onClick)="submitSupplier()"></p-button>
        </div>
    </div>
</p-dialog>

<div [formGroup]="invoiceForm">
    <table>
        <tr>
            <td>
                Supplier
            </td>
            <td>
                <div class="supplier-container">
                    <p-dropdown placeholder="Select" [options]="suppliers" optionLabel="name" formControlName="supplier"></p-dropdown>
                    <p-button icon="pi pi-plus" label="Add" (onClick)="activateSupplierDialog()"></p-button>
                </div>
            </td>
        </tr>
        <tr>
            <td>
                Invoice number
            </td>
            <td>
                <input pInputText formControlName="invoiceNumber">
            </td>
        </tr>
        <tr>
            <td>
                Invoice date
            </td>
            <td>
                <p-calendar formControlName="date"></p-calendar>
            </td>
        </tr>
        <tr>
            <td>
                Payment method
            </td>
            <td>
                <p-dropdown placeholder="Select" [options]="paymentTypes" optionLabel="name" formControlName="paymentType" (onChange)="onPaymentTypeChange($event)"></p-dropdown>
            </td>
        </tr>
        <tr>
            <td>
                Paid by
            </td>
            <td>
                <p-dropdown [options]="paidByList" formControlName="paidBy"></p-dropdown>
            </td>
        </tr>
        <tr>
            <td>
                Amount
            </td>
            <td>
                <input pInputText formControlName="amount">
            </td>
        </tr>
        <tr>
            <td>File</td>
            <td>
                <p-fileUpload #fileUploader mode="basic" [auto]="false" (onSelect)="onFileSelect($event.currentFiles)"
                    [maxFileSize]="16000000" chooseIcon="pi pi-none" chooseLabel="Upload file">
                </p-fileUpload>
            </td>
        </tr>
        <tr>
            <td>
                Comment
            </td>
            <td>
                <textarea pInputTextarea rows="10" cols="50" formControlName="comment"></textarea>
            </td>
        </tr>
        <tr>
            <td>
                Paid date: 
            </td>
            <td>
                <p-calendar formControlName="paidDate"></p-calendar>
            </td>
        </tr>
    </table>

    <div>
        <p-button label="Submit" [disabled]="isCreatingInvoice" (onClick)="submit()"></p-button>
    </div>
</div>